export default __webpack_public_path__ + "static/media/coche-hidrogeno2.fdffb987.jpg";